import { createQueryParams, handleAPIResponse } from '@/@shared/api/handlers/apiResponse';
import { authFetcher } from '@/model/openAPI/auth-server/instance';
import {
	AuthController_signupEmail_Body,
	AuthController_signupEmail_Response,
	AuthController_signupOauth_Body,
	AuthController_signupOauth_Response,
	AuthController_signinEmail_Body,
	AuthController_signinEmail_Response,
	AuthController_signinOauth_Body,
	AuthController_signinOauth_Response,
	AuthController_signinOauthWeb_Body,
	AuthController_signinOauthWeb_Response,
	AuthController_signinEmailWeb_Body,
	AuthController_signinEmailWeb_Response,
	AuthController_getWebToken_Body,
	AuthController_getWebToken_Response,
	AuthController_grantBusinessAccountOwner_Params,
	AuthController_grantBusinessAccountOwner_Body,
	AuthController_grantBusinessAccountOwner_Response,
	AuthController_grantBusinessAccountAdmin_Params,
	AuthController_grantBusinessAccountAdmin_Body,
	AuthController_grantBusinessAccountAdmin_Response,
	AuthController_selfReleaseBusinessAccountAdmin_Body,
	AuthController_selfReleaseBusinessAccountAdmin_Response,
	AuthController_releaseBusinessAccountAdmin_Params,
	AuthController_releaseBusinessAccountAdmin_Response,
	AuthController_getBusinessAccountMember_Params,
	AuthController_getBusinessAccountMember_Response,
	AuthController_getBusinessAuthority_Params,
	AuthController_getBusinessAuthority_Response,
	AuthController_validateAccessToken_Body,
	AuthController_validateAccessToken_Response,
	AuthController_refreshToken_Body,
	AuthController_refreshToken_Response,
	AuthController_sendEmail_Body,
	AuthController_sendEmail_Response,
	AuthController_verifyEmail_Body,
	AuthController_verifyEmail_Response,
	AuthController_webRefresh_Response,
	AuthController_resetPassword_Body,
	AuthController_resetPassword_Response,
	AuthController_makeBusinessAccount_Body,
	AuthController_makeBusinessAccount_Response,
	AuthController_checkBusinessLinked_Body,
	AuthController_checkBusinessLinked_Response,
	AuthController_requestDeviceAutorization_Body,
	AuthController_requestDeviceAutorization_Response,
	AuthController_approveDevice_Params,
	AuthController_approveDevice_Response,
	AuthController_requestDeviceToken_Body,
	AuthController_requestDeviceToken_Response,
	AuthController_handleAppleAccountCallback_Body,
	AuthController_handleAppleAccountCallback_Response,
} from '@/domains/auth/types/validated';

// openapi-fetch HTTP 메서드들 destructuring (싱글톤 인스턴스)
const { GET, POST, PUT, PATCH, DELETE } = authFetcher;

/**
 * email 등록
 */
export const createAuthSignupEmail = async (body: AuthController_signupEmail_Body) => {
	return handleAPIResponse<AuthController_signupEmail_Response>(
		POST('/auth/signup/email', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * oauth 등록
 */
export const createAuthSignupOauth = async (body: AuthController_signupOauth_Body) => {
	return handleAPIResponse<AuthController_signupOauth_Response>(
		POST('/auth/signup/oauth', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * email 등록
 */
export const createAuthSigninEmail = async (body: AuthController_signinEmail_Body) => {
	return handleAPIResponse<AuthController_signinEmail_Response>(
		POST('/auth/signin/email', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * oauth 등록
 */
export const createAuthSigninOauth = async (body: AuthController_signinOauth_Body) => {
	return handleAPIResponse<AuthController_signinOauth_Response>(
		POST('/auth/signin/oauth', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * oauth 등록
 */
export const createAuthSigninWebOauth = async (body: AuthController_signinOauthWeb_Body) => {
	return handleAPIResponse<AuthController_signinOauthWeb_Response>(
		POST('/auth/signin/web/oauth', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * email 등록
 */
export const createAuthSigninWebEmail = async (body: AuthController_signinEmailWeb_Body) => {
	return handleAPIResponse<AuthController_signinEmailWeb_Response>(
		POST('/auth/signin/web/email', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * web 등록
 */
export const createAuthSwitchWeb = async (body: AuthController_getWebToken_Body) => {
	return handleAPIResponse<AuthController_getWebToken_Response>(
		POST('/auth/switch/web', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * owner 등록
 */
export const createAuthBusinessOwner = async (
	params: AuthController_grantBusinessAccountOwner_Params,
	body: AuthController_grantBusinessAccountOwner_Body
) => {
	return handleAPIResponse<AuthController_grantBusinessAccountOwner_Response>(
		POST('/auth/business/owner', {
			params,
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * admin 등록
 */
export const createAuthBusinessAdmin = async (
	params: AuthController_grantBusinessAccountAdmin_Params,
	body: AuthController_grantBusinessAccountAdmin_Body
) => {
	return handleAPIResponse<AuthController_grantBusinessAccountAdmin_Response>(
		POST('/auth/business/admin', {
			params,
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * admin 삭제
 */
export const removeAuthBusinessAdmin = async (body: AuthController_selfReleaseBusinessAccountAdmin_Body) => {
	return handleAPIResponse<AuthController_selfReleaseBusinessAccountAdmin_Response>(
		DELETE('/auth/business/admin', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * auth 삭제
 */
export const removeAuthBusinessAdminId = async (params: AuthController_releaseBusinessAccountAdmin_Params) => {
	return handleAPIResponse<AuthController_releaseBusinessAccountAdmin_Response>(
		DELETE('/auth/business/admin/{userId}', {
			params,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * member 조회
 */
export const fetchAuthBusinessMember = async (params: AuthController_getBusinessAccountMember_Params) => {
	return handleAPIResponse<AuthController_getBusinessAccountMember_Response>(
		GET('/auth/business/member', {
			params,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * authority 조회
 */
export const fetchAuthBusinessAuthority = async (params: AuthController_getBusinessAuthority_Params) => {
	return handleAPIResponse<AuthController_getBusinessAuthority_Response>(
		GET('/auth/business/authority', {
			params,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * validate 등록
 */
export const createAuthInternalTokenValidate = async (body: AuthController_validateAccessToken_Body) => {
	return handleAPIResponse<AuthController_validateAccessToken_Response>(
		POST('/auth/internal/token/validate', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * refresh 등록
 */
export const createAuthInternalTokenRefresh = async (body: AuthController_refreshToken_Body) => {
	return handleAPIResponse<AuthController_refreshToken_Response>(
		POST('/auth/internal/token/refresh', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * send 등록
 */
export const createAuthEmailSend = async (body: AuthController_sendEmail_Body) => {
	return handleAPIResponse<AuthController_sendEmail_Response>(
		POST('/auth/email/send', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * verify 등록
 */
export const createAuthEmailVerify = async (body: AuthController_verifyEmail_Body) => {
	return handleAPIResponse<AuthController_verifyEmail_Response>(
		POST('/auth/email/verify', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * refresh 등록
 */
export const createAuthWebRefresh = async () => {
	return handleAPIResponse<AuthController_webRefresh_Response>(POST('/auth/web/refresh'), {
		throwOnError: false,
		enableLogging: false,
	});
};

/**
 * password 수정
 */
export const modifyAuthPassword = async (body: AuthController_resetPassword_Body) => {
	return handleAPIResponse<AuthController_resetPassword_Response>(
		PATCH('/auth/password', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * account 등록
 */
export const createAuthCmsBusinessAccount = async (body: AuthController_makeBusinessAccount_Body) => {
	return handleAPIResponse<AuthController_makeBusinessAccount_Response>(
		POST('/auth/cms/business/account', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * business 등록
 */
export const createAuthInternalCheckBusiness = async (body: AuthController_checkBusinessLinked_Body) => {
	return handleAPIResponse<AuthController_checkBusinessLinked_Response>(
		POST('/auth/internal/check/business', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * device 등록
 */
export const createAuthDevice = async (body: AuthController_requestDeviceAutorization_Body) => {
	return handleAPIResponse<AuthController_requestDeviceAutorization_Response>(
		POST('/auth/device', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * approve 등록
 */
export const createAuthDeviceApprove = async (params: AuthController_approveDevice_Params) => {
	return handleAPIResponse<AuthController_approveDevice_Response>(
		POST('/auth/device/approve', {
			params,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * token 등록
 */
export const createAuthDeviceToken = async (body: AuthController_requestDeviceToken_Body) => {
	return handleAPIResponse<AuthController_requestDeviceToken_Response>(
		POST('/auth/device/token', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};

/**
 * callback 등록
 */
export const createAuthAppleAccountCallback = async (body: AuthController_handleAppleAccountCallback_Body) => {
	return handleAPIResponse<AuthController_handleAppleAccountCallback_Response>(
		POST('/auth/apple/account/callback', {
			body,
		}),
		{ throwOnError: false, enableLogging: false }
	);
};
